import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/care-guides-hub/components/CareGuidesInteractive.tsx");
